{
  "validation.maxAttachments": "添付ファイルは最大{{max}}個までアップロードできます。",
  "validation.minAttachments": "少なくとも{{min}}個の添付ファイルが必要だよ",
  "validation.maxAttachmentSize": "添付ファイルは{{max}}メガバイトを超えないようにしてくださいね。",
  "validation.attachmentListItemRequired": "{{category}}\"の添付ファイルを提供してください",
  "validation.attachmentListItemMaxAttachments": "{{category}}\" の {{max}} 添付ファイルのみが許可されます",
  "validation.attachmentListItemMaxAttachmentSize": "{{category}}添付ファイルは{{max}}メガバイトより大きくすることはできません",
  "attachment.bsoCategory.DiagnosticReport": "診断レポート",
  "attachment.bsoCategory.InvoiceDocument": "請求書",
  "attachment.bsoCategory.ShippingDocument": "出荷書類",
  "attachment.bsoCategory.Letter": "手紙",
  "attachment.bsoCategory.PictureReference": "画像参照",
  "attachment.bsoCategory.BugReport": "バグレポート",
  "attachment.bsoCategory.Other": "その他",
  "attachment.bsoCategory.Unclassified": "未分類",
  "attachment.bsoCategory.ServiceForms": "サービスフォーム",
  "attachment.bsoCategory.RegistrationDocument": "登録書類",
  "attachment.bsoCategory.ShopInside": "店内の写真",
  "attachment.bsoCategory.ShopImageMigration": "ショップ画像の移行",
  "attachment.bsoCategory.ShopImage": "店頭写真",
  "attachment.uploadButton": "{{category}}をアップロード",
  "attachment.uploadDropdown": "ファイルをアップロード"
}